/* eslint-disable no-shadow-restricted-names */
/* eslint-disable no-unused-vars */
/* global $ */

( function( window, undefined ) {
	window.$ = window.jQuery || {};
}( window ) );

/**
 * @requires lib/popper.min.js
 * @requires lib/bootstrap.min.js
 * @requires lib/jquery.validate.js
 * @requires lib/jquery.waypoints.min.js
 * @requires lib/lottie.min.js
 */

/**
 * app is main application literal object that defines application context and
 * it provide public api interface
 */

const app = ( function( window, document, undefined ) {
	const $window = $( window );
	const $document = $( document );
	const $html = $( 'html' );
	const $page = $( 'body' );

	const $pageNavToggler = $( '#toggle-mobile-nav' );

	const $b2bSteps = $( '.flow-step' );
	const $b2bForm = $( '#frm-b2b' );

	/**
	 * Web client classification
	 *
	 * @access private
	 * @interface _client
	 * @example _client.userAgent
	 * @example _client.clientOS()
	 * @example _client.init()
	 */
	const _client = {
		userAgent: navigator.userAgent || navigator.vendor || window.opera,
		init() {
			$page.addClass( 'os-' + _client.clientOS() );

			$page.addClass( 'browser-' + _client.clientBrowser() );
		},
		clientOS() {
			let os = 'other';

			if ( /windows/i.test( _client.userAgent ) ) {
				os = 'windows';
			}

			if ( /Mac/.test( _client.userAgent ) && ! window.MSStream ) {
				os = 'osx';
			}

			if ( /Linux/.test( _client.userAgent ) && ! window.MSStream ) {
				os = 'linux';
			}

			if ( /X11/.test( _client.userAgent ) && ! window.MSStream ) {
				os = 'unix';
			}

			if ( /android/i.test( _client.userAgent ) ) {
				os = 'android';
			}

			if ( /iPad|iPhone|iPod/.test( _client.userAgent ) && ! window.MSStream ) {
				os = 'ios';
			}

			if ( /TV/.test( _client.userAgent ) && ! window.MSStream ) {
				os = 'other';
			}

			return os;
		},
		clientBrowser() {
			let browser = 'other';

			if ( /chrome|chromium|crios/i.test( _client.userAgent ) ) {
				browser = 'chrome';
			} else if ( /firefox|fxios/i.test( _client.userAgent ) ) {
				browser = 'firefox';
			} else if ( /safari|Safari/.test( _client.userAgent ) && ! window.MSStream ) {
				browser = 'safari';
			} else if ( /opr\//.test( _client.userAgent ) && ! window.MSStream ) {
				browser = 'opera';
			} else if ( /edg/.test( _client.userAgent ) && ! window.MSStream ) {
				browser = 'edge';
			}

			return browser;
		},
	};

	const _cookies = {
		getCookie( cookieName ) {
			const cookies = Object.assign( {}, ...document.cookie.split( '; ' ).map( ( cookie ) => {
				const name = cookie.split( '=' )[ 0 ];
				const value = cookie.split( '=' )[ 1 ];

				return { [ name ]: value };
			} ) );

			return cookies[ cookieName ];
		},

		setCookie( cookie ) {
			document.cookie = cookie;
		},
	};

	/**
	 * SVG json animations
	 *
	 * @access public
	 * @interface app.animations
	 * @example app.animations.animate( 'animation_01', 'animation_element', '../path/animation.json');
	 * @example app.animations.animate( 'animation_01', 'animation_element', '../path/animation.json', true, false);
	 */
	const _animations = {
		animate( animation, element, url, loop, autoplay ) {
			if ( window.lottie ) {
				window[ animation ] = window.lottie.loadAnimation( {
					container: element,
					renderer: 'svg',
					loop,
					autoplay,
					path: url,
					rendererSettings: {
						preserveAspectRatio: 'xMidYMid meet',
						scaleMode: 'noScale',
					},
				} );
			}
		},
	};

	// Handle sidebar
	// _sidebar.show();
	const _sidebar = {
		init() {
			$( 'a[href="#brands"]' ).on( 'click', ( event ) => {
				event.preventDefault();

				this.show();
			} );

			$( '.sidebar-overlay' ).on( 'click', ( event ) => {
				if ( $( event.target ).is( '.sidebar-overlay' ) ) {
					this.hide();
				}
			} );

			$( '[data-action=sidebar-close]' ).on( 'click', () => {
				this.hide();
			} );

			$document.on( 'keyup', ( e ) => {
				if ( e.key === 'Escape' ) {
					this.hide();
				}
			} );

			// Check if sidebr shoud be opened on load
			if ( window.location.hash === '#brands' ) {
				_sidebar.show();
			}
		},
		show() {
			$html.addClass( 'sidebar-is-open' );

			_events.amp.log( 'PITCH - Business Pop Up', { type: 'Other', application: 'Pitch' } );
		},
		hide() {
			$html.removeClass( 'sidebar-is-open' );

			setTimeout( () => {
				_b2bForm.reset();
			}, 1000 );
		},
		toggle() {
			_sidebar[ $html.is( 'sidebar-is-open' ) ? 'hide' : 'show' ]();
		},
	};

	/**
	 * Mobile nav
	 *
	 * @access private
	 * @interface _mobileNav
	 * @example _mobileNav.init()
	 */
	const _mobileNav = {
		init() {
			this.checkIfOpen();

			$pageNavToggler.on( 'change', () => {
				this.checkIfOpen();
			} );
		},
		checkIfOpen() {
			$html[ $pageNavToggler.is( ':visible' ) && $pageNavToggler.is( ':checked' ) ? 'addClass' : 'removeClass' ]( 'nav-is-expanded' );
		},
		reset: () => {
			$pageNavToggler.prop( 'checked', false ).trigger( 'change' );
		},
	};

	/**
	 * Language picker
	 *
	 * @access private
	 * @interface _languagePicker
	 * @example _languagePicker.init()
	 */
	const _languagePicker = {
		init() {
			$( '#language-picker' ).first().on( 'change', ( event ) => {
				window.location.href = event.target.value;
			} );
		},
	};

	/**
	 * Site and User Geolocation
	 *
	 * @access private
	 * @interface _geoLocation
	 * @example _geoLocation.fetchUserRegion()
	 */
	const _geoLocation = {
		async fetchUserRegion() {
			const requestOptions = {
				method: 'GET',
				redirect: 'follow',
			};

			const response = await fetch( 'https://geo.napster.com/', requestOptions );

			const data = await response.json();

			return data;
		},

		async fetchRegionData( regionCode ) {
			const myHeaders = new Headers();
			myHeaders.append( 'Content-Type', 'application/json' );

			const requestOptions = {
				method: 'GET',
				headers: myHeaders,
				redirect: 'follow',
			};

			const response = await fetch( '/wp-json/acf/v3/options/options/countries', requestOptions );

			const data = await response.json();
			const filteredRegions = data.countries.filter( ( x ) => x.country_code === regionCode );

			return filteredRegions[ 0 ] || {};
		},
	};

	/**
	 * Region picker
	 *
	 * @access private
	 * @interface _regionPicker
	 * @example _regionPicker.init()
	 */
	const _regionPicker = {
		init() {
			_geoLocation.fetchUserRegion()
				.then( ( data ) => {
					const userRegion = ( data && data.client && data.client.country_code ) ? data.client.country_code : null;

					if ( userRegion !== $html.data().siteCountryCode && _cookies.getCookie( 'show_region_picker' ) !== 'false' ) {
						_geoLocation.fetchRegionData( userRegion )
							.then( ( regionData ) => {
								if ( Object.entries( regionData ).length !== 0 ) {
									_regionPicker.showRegionPicker( regionData );
								}
							} );
					}
				} );
		},

		showRegionPicker( regionData ) {
			const $regionPicker = $( '#region-picker' );
			const $regionPickerContent = $regionPicker.find( '.picker-content' );
			const $regionPickerActionButton = $regionPicker.find( '.picker-action > a' );
			const $regionPickerClose = $( '#region-picker-close' );

			$regionPickerContent.html( regionData.country_switcher_warning_message );
			$regionPickerActionButton.prop( 'href', regionData.country_slug );
			$regionPickerActionButton.html( regionData.country_switcher_warning_cta );

			setTimeout( () => {
				$regionPicker
					.addClass( 'region-picker' )
					.removeClass( 'd-none' );

				$page.addClass( 'is-region-picker' );
			}, 2000 );

			$regionPickerClose.on( 'click', ( event ) => {
				$regionPicker.detach();

				$page.removeClass( 'is-region-picker' );

				const expires = new Date();

				expires.setDate( expires.getDate() + 5 );

				_cookies.setCookie( 'show_region_picker=false; expires=' + expires + '; path=/' );
			} );
		},
	};

	/**
	 * Forms handling
	 *
	 * @access private
	 * @interface forms
	 * @example _forms.init()
	 */
	const _forms = {
		init() {
			// B2B Form
			_b2bForm.init();
		},
	};

	const _b2bForm = {
		init() {
			const $fullName = $( '#b2b_full_name' );
			const $companyWeb = $( '#b2b_company_website' );
			const $country = $( '#b2b_country' );
			const $email = $( '#b2b_email' );
			const $message = $( '#b2b_tell_us_more' );
			const $btnSubmit = $b2bForm.find( 'button:submit' );

			const _b2b = {};

			_b2bForm.showStep( 1 );

			const b2bForm = $b2bForm.validate( {
				rules: {
					b2b_full_name: {
						required: $fullName.is( '.required' ),
					},
					b2b_company_website: {
						required: $companyWeb.is( '.required' ),
					},
					b2b_country: {
						required: $country.is( '.required' ),
					},
					b2b_email: {
						required: $email.is( '.required' ),
						email: true,
					},
					b2b_tell_us_more: {
						required: $message.is( '.required' ),
					},
				},
				messages: {
					b2b_full_name: {
						required: $fullName.data().errorMessage,
					},
					b2b_company_website: {
						required: $companyWeb.data().errorMessage,
					},
					b2b_country: {
						required: $country.data().errorMessage,
					},
					b2b_email: {
						required: $email.data().errorMessage,
						email: $email.data().errorMessage,
					},
					b2b_tell_us_more: {
						required: $message.data().errorMessage,
					},
				},
			} );

			$b2bForm.on( 'submit', ( event ) => {
				event.preventDefault();

				if ( b2bForm.valid() ) {
					_b2b.name = $fullName.val();
					_b2b.email = $email.val();
					_b2b.company = $companyWeb.val();
					_b2b.country = $country.val();
					_b2b.message = $message.val();

					$btnSubmit.prop( 'disabled', true ).addClass( 'processing' );

					if ( window.appboy ) {
						window.appboy.changeUser( window.appboyUserId );

						window.appboy.openSession();

						window.appboy.logCustomEvent( 'Requested Business Contact', {
							name: _b2b.name,
							email: _b2b.email,
							company: _b2b.company,
							country: _b2b.country,
							more_info: _b2b.message,
						} );

						_events.amp.log( 'PITCH - Business Form Submitted', { type: 'Other', application: 'Pitch' } );
					}

					setTimeout( () => {
						$btnSubmit.prop( 'disabled', false ).removeClass( 'processing' );

						_b2bForm.showStep( 2 );
					}, 3000 );
				}
			} );
		},
		reset() {
			_b2bForm.showStep( 1, function() {
				$b2bForm[ 0 ].reset();
				$b2bForm.data( 'validator' ).resetForm();
			} );
		},
		showStep( step, callback ) {
			$b2bSteps.removeClass( 'active' );

			$b2bSteps.eq( step - 1 ).addClass( 'active' );

			if ( callback ) {
				callback();
			}
		},
	};

	// Log Amplitude Events
	// _events.amp.log( 'Screen View', '{"Application": "Pitch"}' );
	const _events = {
		// Will be initialized through GDPR Cookie consent dialogue
		init() {
			// Handle Screen View Amplitude events
			const ampPageViewEvent = $html.data().ampScreenView;
			const ampPageViewEventProperties = $html.data().ampScreenViewProps || {};

			ampPageViewEventProperties.type = 'Screen View';
			ampPageViewEventProperties.application = 'Pitch';
			ampPageViewEventProperties.referrer = document.referrer;

			// Add stored utm_* params from localStorage
			for (let i = 0; i < window.localStorage.length; i++) {
				const key = window.localStorage.key(i);

				if (key && key.startsWith('utm_')) {
					ampPageViewEventProperties[key] = window.localStorage.getItem(key);
				}
			}

			if ( ampPageViewEvent ) {
				_events.amp.log( ampPageViewEvent, ampPageViewEventProperties );
			}

			// Handle CTA with Amplitude assigned event
			$( '[data-amp-click]' ).on( 'click', function( event ) {
				const eventData = $( this ).data();

				_events.amp.log( eventData.ampClick, eventData.ampProps );
			} );

			// Log header nav events
			$( '#primary-nav, #secondary-nav' ).on( 'click', 'a', function( event ) {
				const $link = $( this );
				const linkData = $( this ).data();
				const dataLinkName = linkData.linkName;
				const dataAmpEvent = linkData.ampEvent;
				const dataAmpProps = linkData.ampProps;

				if ( dataLinkName ) {
					_events.amp.log( dataAmpEvent ? dataAmpEvent : 'PITCH - Header Link', {
						type: 'click',
						application: 'Pitch',
						state: 'signed out',
						screenName: ampPageViewEvent + ' - ' + dataLinkName + ' - Header',
					} );
				} else if ( dataAmpEvent && dataAmpProps ) {
					_events.amp.log( dataAmpEvent, dataAmpProps );
				}
			} );

			// Log footer nav events
			$( '#footer-nav, #footer-secondary-nav' ).on( 'click', 'a', function( event ) {
				const $link = $( this );
				const linkData = $( this ).data();
				const dataLinkName = linkData.linkName;
				const dataAmpEvent = linkData.ampEvent;
				const dataAmpProps = linkData.ampProps;

				if ( dataLinkName ) {
					_events.amp.log( dataAmpEvent ? dataAmpEvent : 'PITCH - Footer Link', {
						type: 'click',
						application: 'Pitch',
						state: 'signed out',
						screenName: ampPageViewEvent + ' - ' + dataLinkName + ' - Footer',
					} );
				} else if ( dataAmpEvent && dataAmpProps ) {
					_events.amp.log( dataAmpEvent, dataAmpProps );
				}
			} );
		},
		amp: {
			log( event, props ) {
				if ( window.amplitude ) {
					// Track custom Amplitude event
					window.amplitude.getInstance().logEvent(
						event,
						props,
					);
				}
			},
		},
	};

	/**
	 * Specific page handling
	 *
	 * @access private
	 * @interface app.page
	 * @example app.page.init()
	 */
	const _page = {
		init() {
			// Handle query string pcode/ocode params
			const queryStringParams = Object.fromEntries( new URLSearchParams( window.location.search ) );

			if ( queryStringParams.hasOwnProperty( 'pcode' ) ) {
				window.localStorage.setItem( 'pcode', queryStringParams.pcode );
			}

			if ( queryStringParams.hasOwnProperty( 'ocode' ) ) {
				window.localStorage.setItem( 'ocode', queryStringParams.ocode );
			}

			// Store all utm_* params from query string into localStorage
			for (const [key, value] of Object.entries(queryStringParams)) {
				if (key.startsWith('utm_')) {
				  window.localStorage.setItem(key, value);
				}
			}
		  
			this.updateLinks();
		},

		updateLinks() {
			const utmParams = {};
		
			// Load all stored utm_* params from localStorage
			for (let i = 0; i < window.localStorage.length; i++) {
			  const key = window.localStorage.key(i);
			  
			  if (key && key.startsWith('utm_')) {
				utmParams[key] = window.localStorage.getItem(key);
			  }
			}
		
			// If no utm params stored, skip
			if (Object.keys(utmParams).length === 0) return;
		
			// Add utm params to all napster.com links
			document.querySelectorAll('a[href*="napster.com"]').forEach(link => {
			  const url = new URL(link.href);
		
			  for (const [key, value] of Object.entries(utmParams)) {
				if (!url.searchParams.has(key)) {
				  url.searchParams.set(key, value);
				}
			  }
		
			  link.href = url.toString(); 
			});

			// Update <input value> links
			document.querySelectorAll('input[value*="napster.com"]').forEach(input => {
				const url = new URL(input.value);

				for (const [key, value] of Object.entries(utmParams)) {
					if (!url.searchParams.has(key)) {
						url.searchParams.set(key, value);
					}
				
					input.value = url.toString();
				
				}
			});
		},
	};

	/**
	 * Specific page handling
	 *
	 * @access private
	 * @interface app.page
	 * @example app.page.init()
	 */
	const _osano = {
		init() {
			// Handle Osano Cookie Consent plugin
			if ( window.Osano ) {
				window.Osano( 'onUiChanged', ( component, stateChange ) => {
					if ( component === 'dialog' && stateChange === 'show' ) {
						const $osanoPrivacyLink = $( '.osano-cm-window a.osano-cm-storage-policy' );

						if ( $osanoPrivacyLink ) {
							$osanoPrivacyLink.attr( 'href', '/' + $html.data().siteCountryCode.toLowerCase() + '/privacy' );
						}
					}
				} );

				if ( $html.data().siteLocale ) {
					// Set osano content language same as site content language
					window.Osano.cm.locale = $html.data().siteLocale;
				}

				$( 'a[href="#cookie_settings"]' ).on( 'click', ( event ) => {
					event.preventDefault();

					window.Osano.cm.showDrawer();
				} );
			}
		},
	};

	/**
	 * App initialization
	 *
	 * @access public
	 * @interface app.start
	 * @example app.start()
	 */
	const _appInit = function() {
		$page[ window.scrollY > 50 ? 'addClass' : 'removeClass' ]( 'is-scrolling' );

		_client.init();
		
		_page.init();

		// Handle amplitude events
		_events.init();

		// Handle cookie consent Osano plugin
		_osano.init();

		// Handle sidebar
		_sidebar.init();

		// Handle mobile navigation
		_mobileNav.init();

		// Handle language picker
		_languagePicker.init();

		// Handle region picker
		_regionPicker.init();

		// Handle forms
		_forms.init();

		// Handle viewport resize
		window.onresize = function() {
			window.requestAnimationFrame( () => {
				_mobileNav.reset();
			} );
		};

		// Handle page scroll
		window.addEventListener(
			'scroll',
			( event ) => {
				$page[ window.scrollY > 50 ? 'addClass' : 'removeClass' ]( 'is-scrolling' );
			},
			{ passive: true },
		);
	};

	return {
		start: _appInit,
		page: _page,
		events: _events,
		cookies: _cookies,
		animations: _animations,
	};
}( this, this.document ) );

// Init page
$( () => {
	app.start();
} );

//# sourceMappingURL=app.js.map
